import { useLocation, useNavigate, useNavigationType } from 'react-router'
import { SetupMFA } from 'mfa'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { useSettings } from '../../hooks/useSettings'
import { useInitialization } from '../../contexts/Initialization'
import { SETUP_TOTP, SETUP_WEB_AUTHN } from '../../constants/routes'
import { getInitialSettings } from '../../utils/getInitialSettings'
import { LEARN_MORE_ABOUT_2FA } from '../../constants/links'
import {
  RECOVERY_OTP_TEXT_FILE_NAME,
  RECOVERY_OTP_TEXT_FILE_TITLE,
} from '../../constants/ui.labels'

function SetupMFAWrapper() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigationType = useNavigationType()
  const { user } = useInitialization() || {}
  const { enabledMFAMechanisms, hasAllMFAEnabled } = useSettings(
    getInitialSettings(user),
  )

  return (
    <SetupMFA
      location={location}
      history={{ action: navigationType }}
      enabledMFAMechanisms={enabledMFAMechanisms}
      hasAllMFAEnabled={hasAllMFAEnabled}
      learnMoreAbout2FAUrl={LEARN_MORE_ABOUT_2FA}
      recoveryFileTitle={RECOVERY_OTP_TEXT_FILE_TITLE}
      recoveryFileName={RECOVERY_OTP_TEXT_FILE_NAME}
      onSetupWebAuthn={() =>
        navigate(SETUP_WEB_AUTHN, { state: location.state })
      }
      onSetupTOTP={() => navigate(SETUP_TOTP, { state: location.state })}
    />
  )
}

export default withCenteredBaseWithMenu(SetupMFAWrapper)
